import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';

export default function ConfirmationDialog(props) {
  const { onClose, value: valueProp, open, isMergeScreen,...other } = props;

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose('ok');
  };

  return (
    <Dialog
      maxWidth="sm"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title">
        {isMergeScreen ? (
          <div>
            Do you really want to delete?
            <h6 style={{ textTransform: "none" }}>
              This record will be removed from the list. To delete it
              permanently, click on Submit.
            </h6>
          </div>
        ) : (
         props.content ? props.content : "Do you really want to delete?"
        )}
      </DialogTitle>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
};